import {AnalyticsEvent} from '../types/analytics';
import * as actionTypes from './analyticsActionTypes';

export function track(event: AnalyticsEvent, data: any = {}) {
    return {
        type: actionTypes.ANALYTICS_TRACK,
        payload: {
            event,
            data,
        },
    };
}

export function trackSuccess(event: AnalyticsEvent, data: any = {}) {
    return {
        type: actionTypes.ANALYTICS_TRACK_SUCCESS,
        payload: {
            event,
            data,
        },
    };
}

export function trackFailed(error: unknown) {
    return {
        type: actionTypes.ANALYTICS_TRACK_FAILED,
        error,
    };
}
